<template>
  <div class="pre-presentation">
    <div class="pre-hd after-bd-b">
      <h3>同屏讲解温馨提示</h3>
      <div class="close" @click="handleClose">
        <i class="iconfont icon-close_line" />
      </div>
    </div>
    <div class="content">
      <p>事先请客户在<span>微信端</span>等待</p>
      <p>点击下方“<span>继续</span>”按钮分享给客户</p>
      <p>
        返回<span>{{ isToBApp ? '掌上职场' : '保险师' }}APP</span>内操作，微信端可实时查看
      </p>
    </div>
    <div class="btn">
      <div class="continue" @click="handleToShare">
        继续
      </div>
      <div class="demo" @click="handleToLink('demo')">
        查看操作演示<i class="iconfont icon-common_problem" />
      </div>
    </div>
  </div>
</template>

<script>
import { isToBApp } from 'base/config'
export default {
  name: 'PrePresentation',
  components: {},
  data() {
    this.isToBApp = isToBApp
    return {}
  },
  watch: {},
  methods: {
    handleToLink() {
      window.WeiyiStatSDK.submit('tongping_tip')
      location.href = isToBApp
        ? 'https://yjj-content-h5.wyins.net/view/newsShare-ins/newsAricleShare.html?uuid=f00a852204f84dac9bef6590827b406a33&nw=1'
        : 'https://app.winbaoxian.com/view/newsShare/newsAricleShare.html?id=31ce31a0912d48949d38735f0857f654&nw=1'
    },
    handleToShare() {
      this.$emit('share')
      window.WeiyiStatSDK.submit('tongping_share')
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'variable.css';
.pre-presentation {
  width: 6rem;
  padding-bottom: 0.42rem;
  font-size: 0.3rem;
  color: #333;
  .pre-hd {
    padding: 0.3rem 0;
    > h3 {
      font-size: 0.34rem;
      font-weight: bold;
      text-align: center;
    }
    .close {
      position: absolute;
      right: 12px;
      top: 11px;
      font-size: 24px;
      &:after {
        @apply --extend-click;
      }
    }
    .icon-close_line {
      font-size: 24px;
      color: #ccc;
    }
  }
  .content,
  .btn {
    padding: 0 0.3rem;
  }
  .content {
    padding-top: 0.3rem;
    font-size: 0.28rem;
    counter-reset: index;
    line-height: 0.5rem;
    p {
      position: relative;
      margin-bottom: 0.21rem;
      padding-left: 0.74rem;
      &:before {
        overflow: hidden;
        position: absolute;
        left: 0.1rem;
        top: 0.1rem;
        content: counter(index);
        counter-increment: index;
        width: 0.3rem;
        height: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
        color: #fff;
        font-size: 0.24rem;
        background-color: var(--primary-color);
        border-radius: 50%;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 0.5rem;
        height: 0.5rem;
        background-color: rgba(0, 127, 219, 0.1);
        border-radius: 50%;
      }
      span {
        color: var(--primary-color);
      }
    }
  }
  .continue {
    margin: 0 0.3rem 0.3rem;
    padding: 0.23rem 0;
    border-radius: 0.12rem;
    font-size: 0.32rem;
    background-color: var(--primary-color);
    color: #fff;
    text-align: center;
  }
  .demo {
    text-align: center;
    font-size: 0.28rem;
    .iconfont {
      margin-left: 0.12rem;
      color: #999;
      font-size: 0.3rem;
    }
  }
}
</style>
